export const environment = {
  production: false,
  apiUrl: "https://apidev.cvdprevent.nhs.uk/"
};
